import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const RANGE_OPTS = [["van", "Van chevaux"], ["prosport", "Pro & Sport"]];
const EXCL_OPTS = [["yes", "Exclusifs Fautras"], ["no", "Non exclusifs"]];

export const countriesOf = (r) => [...new Set((r.sectors || []).map((s) => (s.country || "").toUpperCase()).filter(Boolean))];
export const rangesOf = (r) => [...new Set((r.sectors || []).map((s) => s.range_key).filter(Boolean))];

export const matchResellerFilters = (r, f) => (f.country === "all" || countriesOf(r).includes(f.country))
  && (f.range === "all" || rangesOf(r).includes(f.range))
  && (f.excl === "all" || (f.excl === "yes") === !!r.exclusive);

const Pick = ({ value, onChange, all, options, testid, width = "w-[170px]" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={width} data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all" data-testid={`${testid}-all`}>{all}</SelectItem>
      {options.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`${testid}-${k}`}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const ResellerFilters = ({ list, f, setF }) => {
  const [names, setNames] = useState({});
  useEffect(() => {
    api.get("/countries").then(({ data }) => setNames(Object.fromEntries((data || []).map((c) => [c.code, c.name])))).catch(() => {});
  }, []);
  const codes = [...new Set(list.flatMap(countriesOf))].sort((a, b) => (names[a] || a).localeCompare(names[b] || b, "fr"));
  const count = (k) => list.filter((r) => countriesOf(r).includes(k)).length;
  return (
    <>
      <Pick value={f.country} onChange={(v) => setF({ ...f, country: v })} all="Tous les pays" testid="reseller-filter-country"
        options={codes.map((c) => [c, `${names[c] || c} (${count(c)})`])} />
      <Pick value={f.range} onChange={(v) => setF({ ...f, range: v })} all="Toutes les gammes" testid="reseller-filter-range" options={RANGE_OPTS} />
      <Pick value={f.excl} onChange={(v) => setF({ ...f, excl: v })} all="Exclusifs et non exclusifs" testid="reseller-filter-exclusive" options={EXCL_OPTS} width="w-[200px]" />
    </>
  );
};
